import { useSearchParams } from "react-router-dom";
import { ServiceDiagnostics } from "@/features/admin/service-diagnostics";

const TABS = ["catalog", "matrix", "probe"] as const;
type Tab = (typeof TABS)[number];

export default function AdminServicesPage(){
  const [searchParams] = useSearchParams();
  const sp = Object.fromEntries(searchParams.entries());
  const initialTab: Tab = TABS.includes(sp.tab as Tab) ? (sp.tab as Tab) : "catalog";
  return <ServiceDiagnostics initialTab={initialTab} />;
}
